import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import * as jwt_decode from 'jwt-decode';
import { BloguserService } from 'api/bloguser/bloguser.service';
import { ApiConstant } from 'api/api.constant';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'application-page',
    templateUrl: './bloguserdetails.html',
})
export class BlogUserdetails implements OnInit {
    isIconSelected: boolean = false;
    IconUrl: any;
    IconFile: File;
    searchvalue: String;
    id: any;
    bloguser = []
    userdetails = []
    email: any
    firstname: string;
    lastname: string;
    mobile: any;
    password: any;
    sortdescription: any;
    facebooklink: any;
    youtubelink: any;
    twitterlink: any;
    linkedinlink: any;
    pinterestlink: any;
    githublink: any;
    file: File;
    designation: any
    profileimageurl: any
    constructor(private router: Router,
        private bloguserService: BloguserService,
        private apiconstant: ApiConstant) {
        this.profileimageurl = this.apiconstant.BaseUrl + 'uploads/profilepic/'
    }
    ngOnInit() {
        this.profileimageurl = this.apiconstant.BaseUrl + 'uploads/profilepic/'
        var token = localStorage.getItem('id_token')
        var decoded = jwt_decode(token);
        this.email = decoded.email
        this.bloguserService.allbloguser().then(data => {
            if (data) {
                this.bloguser = data
                for (let i = 0; i < this.bloguser.length; i++) {
                    if (this.email == this.bloguser[i].email) {
                        this.userdetails.push(this.bloguser[i])
                    }
                }
                this.openpage()
            }
            else {
            }
        })
    }
    openpage() {
        this.firstname = this.userdetails[0]['firstname']
        this.email = this.userdetails[0]['email']
        this.lastname = this.userdetails[0].lastname
        this.mobile = this.userdetails[0].mobile
        this.youtubelink = this.userdetails[0].youtubelink
        this.facebooklink = this.userdetails[0].facebooklink
        this.twitterlink = this.userdetails[0].twitterlink
        this.designation = this.userdetails[0].designation
        this.linkedinlink = this.userdetails[0].linkedinlink
        this.pinterestlink = this.userdetails[0].pinterestlink
        this.githublink = this.userdetails[0].githublink
        this.sortdescription = this.userdetails[0].sortdescription
        this.file = this.userdetails[0].profilepic
        this.id = this.userdetails[0].id
        this.password = this.userdetails[0].password;
    }
    createFormData(event) {
        this.file = <File>event.target.files[0];
    }
    removeIconImage() {
        $("#myinfeild").val(null)
        this.IconUrl = "";
        this.IconFile = null;
        this.isIconSelected = false;
    }
    UpdateBlogUser() {
        if (this.firstname == undefined || this.firstname == "") {
            $.notify({
                message: "Please Enter First Name."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else if (this.lastname == undefined || this.lastname == "") {
            $.notify({
                message: "Please Enter Last Name."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else if (this.mobile == undefined || this.mobile == "") {
            $.notify({
                message: "Please Enter Mobile."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else if (this.IconFile == null && this.IconFile == undefined && this.file == null && this.file == undefined) {
            $.notify({
                message: "Please Enter Profile pic."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            let registeruser =
            {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password,
                mobile: this.mobile,
                sortdescription: this.sortdescription,
                youtubelink: this.youtubelink,
                facebooklink: this.facebooklink,
                twitterlink: this.twitterlink,
                linkedinlink: this.linkedinlink,
                pinterestlink: this.pinterestlink,
                githublink: this.githublink
            };
            this.bloguserService.ubloggers(this.id, this.IconFile, registeruser).then(data => {
                if (data) {
                    if (data.status) {
                        this.userdetails = data.data
                        this.openpage()
                        $("#myinfeild").val(null)
                        this.IconUrl = "";
                        this.IconFile = null;
                        this.isIconSelected = false;
                        $.notify({
                            message: "successfully updated."
                        }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                        return;
                    }
                    else {
                        this.ngOnInit()
                    }
                }
                else {
                    this.ngOnInit()
                }
            })
        }
    }
    detectIconImageChange(event) {
        this.isIconSelected = true;
        let files = event.target.files;
        if (files.length === 0)
            return;
        var mimeType = files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        this.IconFile = files[0];
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (_event: any) => {
            var img = new Image();
            img.src = _event.target.result;
            img.onload = () => {
                var width = img.height;
                var height = img.width;
                if (height == 512 && width == 512) {
                    this.IconUrl = reader.result;
                }
                else {
                    this.IconUrl = "";
                    this.IconFile = null;
                    this.isIconSelected = false;
                    alert("Image Size must be 512x512")
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/bloguserdetails/bloguserdetails.page.ts